import { useRef, useEffect } from 'react';

const useInterval = (callback, delay, completed) => {
  const savedCallback = useRef();
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(() => {
    const handler = (...args) => {
      if (savedCallback && savedCallback.current) {
        savedCallback.current(...args);
      }
    };
    if (delay !== null && !completed) {
      const id = setInterval(handler, delay);
      return () => clearInterval(id);
    }
  }, [delay, completed]);
};

export { useInterval };
